module.exports = __webpack_public_path__ + "img/2.a61d9fb3.jpg";